import { createContextLocalStore } from '../createContextLocalStore';

import { FooterStore } from './FooterStore';

const { Provider, useStore } = createContextLocalStore(FooterStore);

export { Provider as FooterStoreProvider, useStore as useFooterStore, FooterStore };
